<template>
  <div>
    <Modal
      v-model="showRecoveryKeyModal"
      cancelText="close"
      headerText="Recovery Key"
      mainActionText=""
    >
      <p>
        The Recovery Key is only kept up to date on devices that currently
        have the Full Disk Encryption Policy applied.
      </p>
      <transition v-bind="overlayTransitionProps">
        <div
          v-if="!(results || error)"
          :class="$style.loadingOverlay"
        >
          <i :class="[ $style.loadingOverlayIndicator, 'jc-progress', 'jc-spin' ]" />
        </div>
        <p
          v-else-if="error"
          :class="$style.error"
        >
          {{ error }}
        </p>
        <p
          v-else
          :class="$style.results"
        >
          {{ results }}
        </p>
      </transition>
    </Modal>
    <button
      v-if="showLink && isFdeKeyPresent(item)"
      :class="$style.viewLink"
      @click="viewRecoveryKeyModal"
    >
      view key
    </button>
    <FlatActionButton
      v-else-if="isFdeKeyPresent(item)"
      :action="viewRecoveryKeyModal"
    >
      view key
    </FlatActionButton>
    <span
      v-else
      ref="dataNotAvailable"
    >
      {{ dataNotAvailable }}
    </span>
  </div>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { mapGetters } from 'vuex';
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';
import Modal from 'client/components/Modal/Modal.vue';
import SystemApi from 'client/api/v2/SystemApi';

const { dataNotAvailable } = Constants.default;

export default {
  name: 'ViewRecoveryKeyButton',

  components: {
    FlatActionButton,
    Modal,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    showLink: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      dataNotAvailable,
      error: null,
      results: null,
      showRecoveryKeyModal: false,
    };
  },

  computed: {
    ...mapGetters('SystemCollection', [
      'isFdeKeyPresent',
    ]),

    overlayTransitionProps() {
      return {
        enterClass: this.$style.loadingOverlayEnter,
        enterActiveClass: this.$style.loadingOverlayEnterActive,
        leaveActiveClass: this.$style.loadingOverlayLeaveActive,
        leaveToClass: this.$style.loadingOverlayLeaveTo,
      };
    },
  },

  methods: {
    viewRecoveryKeyModal() {
      this.showRecoveryKeyModal = true;
      this.results = null;
      this.error = null;
      SystemApi.getRecoveryKey(this.item.id)
        .then((res) => {
          this.results = res.key;
        })
        .catch((err) => {
          this.error = err.message;
        });
    },
  },
};
</script>

<style scoped module>
@value (brandA, grey90, greyDark1, infoBlue) from '~css/colors.css';

.loadingIndicator {
  background-color: grey90;
  color: brandA;
  font-size: 13px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}

.loadingIndicatorIcon {
  display: inline-block;
  font-size: 26px;
  margin-right: 10px;
  vertical-align: middle;
}

.loadingOverlay {
  background-color: rgba(255, 255, 255, 0.5);
  bottom: 0;
  height: 50px;
  left: 0;
  position: relative;
  right: 0;
  top: 0;
}

.loadingOverlayEnterActive {
  transition: opacity 250ms ease-in;
}

.loadingOverlayLeaveActive {
  transition: fadeTransition;
}

.loadingOverlayEnter,
.loadingOverlayLeaveTo {
  opacity: 0;
}

.loadingOverlayIndicator {
  color: brandA;
  font-size: 35px;
  left: 50%;
  margin-left: -20px;
  margin-top: -20px;
  position: absolute;
  top: 50%;
}

.results {
  padding-top: var(--jc-spacer);
  text-align: center;
}

.results,
.error {
  user-select: text;
}

.viewLink {
  background: none;
  border: 0;
  color: infoBlue;
  cursor: pointer;
  font-size: 1em;
  padding: 0;
  text-decoration: underline;
}

.viewLink:hover {
  color: infoBlue;
  text-decoration: none;
}
</style>
